(function () {
  if (window.AnnabProductCardGalleryArrowsV8) return;
  window.AnnabProductCardGalleryArrowsV8 = true;

  function getMainImg(card) {
    return card.querySelector("slideshow-slide:not([hidden]) img") ||
      card.querySelector("slideshow-component img") ||
      card.querySelector(".product-card__content img");
  }

  function getData(card) {
    var script = card.querySelector(".annab-card-gallery-data");
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function hasColor(variant, color) {
    return (variant.options || []).some(function (option) {
      return String(option).toLowerCase() === String(color).toLowerCase();
    });
  }

  function getColorVariant(data, color) {
    return data.variants.find(function (variant) {
      return hasColor(variant, color);
    });
  }

  function getImagesForColor(card) {
    var data = getData(card);
    if (!data) return [];

    var activeSwatch = card.querySelector(".js-color-swatch.is-active");
    var color = activeSwatch ? activeSwatch.getAttribute("data-color-name") : "";

    if (!color) return data.media.map(function (m) { return m.src; });

    var variant = getColorVariant(data, color);
    if (!variant || !variant.featured_media_id) {
      return data.media.map(function (m) { return m.src; });
    }

    var activeMedia = data.media.find(function (m) {
      return String(m.id) === String(variant.featured_media_id);
    });

    if (!activeMedia) return data.media.map(function (m) { return m.src; });

    var nextPositions = data.variants
      .filter(function (v) {
        return !hasColor(v, color) && v.featured_media_id;
      })
      .map(function (v) {
        var media = data.media.find(function (m) {
          return String(m.id) === String(v.featured_media_id);
        });
        return media ? media.position : null;
      })
      .filter(function (pos) {
        return pos && pos > activeMedia.position;
      });

    var endPosition = nextPositions.length ? Math.min.apply(null, nextPositions) : Infinity;

    return data.media
      .filter(function (m) {
        return m.position >= activeMedia.position && m.position < endPosition;
      })
      .map(function (m) {
        return m.src;
      });
  }

  function getImageUrlForWidth(src, width) {
  try {
    var url = new URL(src, window.location.origin);
    url.searchParams.set("width", width);
    return url.href;
  } catch (e) {
    var separator = src.indexOf("?") !== -1 ? "&" : "?";
    return src + separator + "width=" + width;
  }
}

function buildResponsiveSrcset(src) {
  return [320, 480, 640, 900, 1200]
    .map(function (width) {
      return getImageUrlForWidth(src, width) + " " + width + "w";
    })
    .join(", ");
}

function setImage(card, src) {
  var img = getMainImg(card);
  if (!img || !src) return;

  img.src = src;
  img.setAttribute("src", src);
  img.setAttribute("srcset", buildResponsiveSrcset(src));

  updateDots(card);
}

  function showSlide(card, direction) {
    var images = getImagesForColor(card);
    if (images.length < 2) return;

    var current = Number(card.dataset.annabGalleryIndex || 0);
    var next = current + direction;

    if (next < 0) next = images.length - 1;
    if (next >= images.length) next = 0;

    var effectClass = direction > 0 ? "is-annab-swiping-next" : "is-annab-swiping-prev";

card.classList.add(effectClass);

setTimeout(function () {
  card.dataset.annabGalleryIndex = next;
  setImage(card, images[next]);

  setTimeout(function () {
    card.classList.remove(effectClass);
  }, 80);
}, 170);
  }

  function updateDots(card) {
  var dotsWrap = card.querySelector(".annab-card-gallery-dots");
  if (!dotsWrap) return;

  var images = getImagesForColor(card);
  var current = Number(card.dataset.annabGalleryIndex || 0);

  dotsWrap.innerHTML = "";

  images.forEach(function (_, index) {
    var dot = document.createElement("span");
    dot.className = "annab-card-gallery-dot";

    if (index === current) {
      dot.classList.add("is-active");
    }

    dotsWrap.appendChild(dot);
  });
}

function enableSwipe(card, element) {
  if (!element || element.dataset.annabSwipeReady === "true") return;

  element.dataset.annabSwipeReady = "true";

  var startX = 0;
  var startY = 0;

  element.addEventListener("touchstart", function (e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  element.addEventListener("touchend", function (e) {
    var endX = e.changedTouches[0].clientX;
    var endY = e.changedTouches[0].clientY;

    var diffX = endX - startX;
    var diffY = endY - startY;

    if (Math.abs(diffX) < 35) return;
    if (Math.abs(diffX) < Math.abs(diffY)) return;

    if (diffX < 0) {
      showSlide(card, 1);
    } else {
      showSlide(card, -1);
    }
  }, { passive: true });
}

  function createArrows(card) {
    if (card.dataset.annabGalleryReady === "true") return;

    var slideshow = card.querySelector("slideshow-component");
    if (!slideshow) return;

    card.dataset.annabGalleryReady = "true";
    card.dataset.annabGalleryIndex = 0;
    setTimeout(function () {
  updateDots(card);
}, 50);
    slideshow.style.position = "relative";

    var nav = document.createElement("div");
    nav.className = "annab-card-gallery-nav";

    var prev = document.createElement("button");
    prev.type = "button";
    prev.className = "annab-card-gallery-btn annab-card-gallery-btn--prev";
    prev.innerHTML = "&#10094;";

    var next = document.createElement("button");
    next.type = "button";
    next.className = "annab-card-gallery-btn annab-card-gallery-btn--next";
    next.innerHTML = "&#10095;";

    prev.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      showSlide(card, -1);
    }, true);

    next.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      showSlide(card, 1);
    }, true);

    nav.appendChild(prev);
    nav.appendChild(next);
    var dots = document.createElement("div");
dots.className = "annab-card-gallery-dots";
slideshow.appendChild(dots);
    slideshow.appendChild(nav);
    enableSwipe(card, slideshow);
  }

  function init() {
    document.querySelectorAll(".product-card").forEach(createArrows);
  }

  document.addEventListener("click", function (e) {
    var swatch = e.target.closest(".js-color-swatch");
    if (!swatch) return;

    var card = swatch.closest(".product-card");
    if (!card) return;

    setTimeout(function () {
      card.dataset.annabGalleryIndex = 0;
      var images = getImagesForColor(card);
      if (images.length) setImage(card, images[0]);
    }, 200);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", init);
  document.addEventListener("shopify:section:load", init);
})();